import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  earth_file: Yup.string().required("Earth file is required!"),
});
